import { runtimeEnvironment } from './runtime-environment';
export const environment = {
    connectorUrl: '',
    production: false,
    apiUrl: 'https://api.pre.screenleads.com',
    offersUrl: 'https://offerspre.screenleads.com',
    mcpUrl: 'https://mcp.pre.screenleads.com/mcp',
    mcpDocsUrl: '/docs/mcp/GUIA_PRUEBA_MCP_SCREENLEADS_PRE.pdf',
    mcpPostmanCollectionUrl: '/docs/mcp/SCREENLEADS_MCP_PRE.postman_collection.json',
    mcpPostmanEnvironmentUrl: '/docs/mcp/SCREENLEADS_MCP_PRE.postman_environment.json',
    stripePublishableKey: 'pk_test_51SKL4zKDpRuaO55wYyH1SiKGe4MfwpMxGetgwthMqmbyFDYjnswNDIa5ELiCKupFXq0nb1qGQUod9zBV6JADc17R00PXyUw7Zp',
    stripeMode: 'test' as 'test'|'live',
    ...runtimeEnvironment()
};
